export const FileExtensions = {
    SDF: 'sdf',
    MOL: 'mol',
    NMRIUM: 'nmrium',
    JSON: 'json',
    JCAMP: 'jcamp',
    DX: 'dx',
    JDX: 'jdx',
    JDF: 'jdf',
    NMREDATA: 'nmredata',
    SMILES: 'smiles',
    SMI: 'smi',
};
//# sourceMappingURL=constants.js.map